var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"wrapperDiv"},[_c('h1',[_c('span',[_vm._v(" "+_vm._s(_vm.$t("Thank Y"))),_c('i',{staticClass:"far fa-smile-beam"}),_vm._v(_vm._s(_vm.$t("u")))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }